module.exports = __webpack_public_path__ + "static/img/sspg_06.90644ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sspg/sspg_06.jpg
// module id = 2Ua4
// module chunks = 1